import { useMutation } from "@tanstack/react-query";
import type { DelayCategory } from "../../categories/models/CatalogCategory";
import {
  deleteCatalogCategory,
  upsertCatalogCategory,
} from "../../categories/repositories/CatalogCategoriesRepository";

export const useUpsertDelayCategoryMutation = () => {
  return useMutation({
    mutationFn: async (category: DelayCategory) => {
      const resp = await upsertCatalogCategory(category);
      if (!resp.ok) throw new Error(resp.message);
      return resp;
    },
  });
};

export const useDeleteDelayCategoryMutation = () => {
  return useMutation({
    mutationFn: async (delayCategoryId: number) => {
      const resp = await deleteCatalogCategory(delayCategoryId);
      if (!resp.ok) throw new Error(resp.message);
      return resp;
    },
  });
};
